export default __webpack_public_path__ + "static/bucharest_hotel_2-aadef280fac9f356c86fc2599ac7c048.webp";